'use client';

import { ContentDialogForm } from '@/components/admin/contents/content-dialog-form/content-create-dialog-form';
import { ContentType } from '@jlg-website/shared/constants';

export function ThingsToKnowAboutCreateOption({ onCreate }: { onCreate: () => void }) {
  return (
    <ContentDialogForm onCreateAction={onCreate} contentTypeName={ContentType.ThingsToKnowAbout} />
  );
}

export default ThingsToKnowAboutCreateOption;
